import { useCallback, useState } from 'react'

export const useGroupFilter = (callbackFn?: VoidFunction) => {
  const [filteredGroupIds, setFilteredGroupIds] = useState<string[]>([])

  const onChangeFilteredGroupIds = useCallback(
    (groupIds: string[]) => {
      setFilteredGroupIds(groupIds)
      callbackFn?.()
    },
    [callbackFn]
  )

  return {
    filteredGroupIds,
    onChangeFilteredGroupIds
  }
}
